if(!customElements.get('upsell-popup')) {
  customElements.define(
    'upsell-popup',
    class UpsellPopup extends HTMLElement {
      constructor() {
        super();

        this.closeEls = this.querySelectorAll('.upsell-modal__close');
        this.enabled = true;

        this.closeEls.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
          });
        });
        
        document.querySelector('.product-single__form-original')?.addEventListener('submit', this.onOriginalFormSubmit.bind(this));
        document.addEventListener('click', this.onPreorderClick.bind(this), true);
      }
      
      connectedCallback() {
        if(this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
      }

      show(opener) {
        if(!this.enabled) return;
        this.openedBy = opener;
        document.body.classList.add('upsell-modal--open');
        this.setAttribute('open', '');
        document.body.dispatchEvent(new CustomEvent('upsellModalOpened'));
        trapFocus(this, this.querySelector('[role="dialog"]'));
      }
      
      hide() {
        document.body.classList.remove('upsell-modal--open');
        document.body.dispatchEvent(new CustomEvent('upsellModalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        document.querySelector('.product-single__form-original')?.submit();
        this.enabled = false;
      }
      
      onOriginalFormSubmit(event) {
        event.preventDefault();
        this.show(event.submitter ?? null);
      }

      onPreorderClick(event) {
        if(event.target && event.target.closest('button[type="submit"]')?.closest('.spurit-po-wrapper')) {
          event.stopPropagation();
          event.preventDefault();
          this.show(event.submitter ?? null);
        }
      }
    }
  );
}
